/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { GRID_ROW_COL_MAX_TEXT } from '../../constants';
import ifoIconBlue from '../../images/announcement_icon_blue.svg';
import GridInfoBox from './EnhancedGridFeature/GridInfoBox';

function selectInputText(element) {
  element.setSelectionRange(element.value.length, element.value.length);
}

export default class GenericInlineEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: this.props.editing,
      text: this.props.text,
      minLength: this.props.minLength,
      maxLength: this.props.maxLength,
    };
  }

  UNSAFE_componentWillMount() {
    this.isInputValid = this.props.validate || this.isInputValid;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isTextChanged = nextProps.text !== this.props.text;
    const isEditingChanged = nextProps.editing !== this.props.editing;
    const nextState = {};
    if (isTextChanged) {
      nextState.text = nextProps.text;
    }
    if (isEditingChanged) {
      nextState.editing = nextProps.editing;
    }
    if (isTextChanged || isEditingChanged) {
      this.setState(nextState);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const inputElem = ReactDOM.findDOMNode(this.input);
    if (this.state.editing && !prevState.editing) {
      if (inputElem) {
        inputElem.focus();
        selectInputText(inputElem);
      }
    } else if (this.state.editing && prevProps.text !== this.props.text) {
      this.finishEditing();
    }
  }

  startEditing = e => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
    this.setState({ editing: true, text: this.props.text });
  };

  finishEditing = () => {
    if (
      this.isInputValid(this.state.text) &&
      this.props.text !== this.state.text
    ) {
      this.commitEditing();
    } else if (
      this.props.text === this.state.text ||
      !this.isInputValid(this.state.text)
    ) {
      this.cancelEditing();
    }
  };

  cancelEditing = () => {
    this.setState({ editing: false, text: this.props.text });
  };

  commitEditing = () => {
    this.setState(prevState => ({ editing: false, text: prevState.text }));
    const newProp = {};
    newProp[this.props.paramName] = this.state.text;
    this.props.change(newProp);
  };

  clickWhenEditing = e => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  };

  isInputValid = text =>
    text.length >= this.state.minLength && text.length <= this.state.maxLength;

  keyDown = event => {
    if (event.keyCode === 13) {
      this.finishEditing();
    } else if (event.keyCode === 27) {
      this.cancelEditing();
    }
  };

  textChanged = event => this.setState({ text: event.target.value.trim() });

  render() {
    if (this.props.isDisabled) {
      const Element = this.props.element || this.props.staticElement;
      return (
        <Element className={this.props.className} style={this.props.style}>
          {this.state.text || this.props.placeholder}
        </Element>
      );
    }

    if (!this.state.editing) {
      const Element = this.props.element || this.props.staticElement;
      return (
        <Element
          className={this.props.className}
          onDoubleClick={this.props.crosstabViewFlag ? () => {} : this.startEditing}
          onClick={this.props.crosstabViewFlag ? () => {} : this.props.onClick}
          tabIndex={this.props.tabIndex}
          style={{
            outline: 'none',
            width: `${this.props.showFootNoteIcon.length > 0 ? 'calc(100% - 20px)' : 'width: 100%'}`,
            display: 'inline'
          }}
        >
          {this.state.text || this.props.placeholder}
          {this.props.originalLabel && this.props.toggleLabel &&
          this.props.originalLabel.length >= GRID_ROW_COL_MAX_TEXT ? '...' : ''}
          {this.props.showFootNoteIcon.length > 0 && <GridInfoBox
            Positions={['bottom', 'right']}
            InfoBoxButtonInner={<img
              src={ifoIconBlue}
              alt="Footnote Icon" title="" />}
            Align="start"
            containerClassName="mrc-accredited-popover"
            btnWidth="20px"
            footNotes={this.props.showFootNoteIcon}
            footNoteList={this.props.crosstabFootNotes}
          />}
        </Element>
      );
    }

    const Element = this.props.element || this.props.editingElement;
    return (
      <Element
        onClick={this.clickWhenEditing}
        onKeyDown={this.keyDown}
        onBlur={this.finishEditing}
        className={this.props.activeClassName}
        placeholder={this.props.placeholder}
        defaultValue={this.state.text}
        onChange={this.textChanged}
        style={this.props.style}
        ref={node => (this.input = node)}
        maxLength={this.state.maxLength}
      />
    );
  }
}

GenericInlineEdit.propTypes = {
  originalLabel: PropTypes.string,
  text: PropTypes.string.isRequired,
  paramName: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  element: PropTypes.element,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  validate: PropTypes.func,
  stopPropagation: PropTypes.func,
  style: PropTypes.shape({}),
  editingElement: PropTypes.string,
  staticElement: PropTypes.string,
  tabIndex: PropTypes.number,
  isDisabled: PropTypes.bool,
  editing: PropTypes.bool,
  crosstabViewFlag: PropTypes.bool,
  toggleLabel: PropTypes.bool,
  showFootNoteIcon: PropTypes.bool,
  crosstabFootNotes: PropTypes.shape({}),
};

GenericInlineEdit.defaultProps = {
  minLength: 1,
  maxLength: 256,
  editingElement: 'input',
  staticElement: 'span',
  tabIndex: 0,
  isDisabled: false,
  editing: false,
  showFootNoteIcon: false,
};
